// extracted by mini-css-extract-plugin
export default {"external":"aFTVcZ","wrapper":"bFTVcZ","security":"cFTVcZ","buttonWrapper":"dFTVcZ"};